/**
 * Currencies API
 * Returns hardcoded list of available currencies
 * (Endpoint /api/v1/tools/currencies returns 404)
 */

import { CurrencyItem } from '../types/currencies-types';
import { ALL_CURRENCIES } from '../constants/currencies-constants';

export class CurrenciesApi {
  constructor(
    private readonly baseUrl: string,
    private readonly tokenManager: any
  ) {}

  /**
   * Get available currencies
   * Note: Endpoint /api/v1/tools/currencies is not available (404)
   * Returns hardcoded list from constants
   */
  async getCurrencies(): Promise<CurrencyItem[]> {
    console.log('[CurrenciesApi] Returning hardcoded currencies list');
    return ALL_CURRENCIES;
  }
}
